// extracted by mini-css-extract-plugin
module.exports = {"brandDesign":"BrandDesign_brandDesign__nO9lm","first":"BrandDesign_first__2DqZL","second":"BrandDesign_second__39706"};